import { render, staticRenderFns } from "./customer-visual-profile.vue?vue&type=template&id=7bdf86c8&scoped=true"
import script from "./customer-visual-profile.vue?vue&type=script&lang=js"
export * from "./customer-visual-profile.vue?vue&type=script&lang=js"
import style0 from "./customer-visual-profile.vue?vue&type=style&index=0&id=7bdf86c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdf86c8",
  null
  
)

export default component.exports